import https from 'utils/https';

// Additional Document HUB

export async function GetAllMerchantsExtraDocs(params) {
    const response = await https().get(`/compliance/doc_upload_files/`, {
        params,
    });
    return response.data;
}
